<template>
  <QuestionBase :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
                :question="question"
                :valid="data !== null">
    <InputRadio v-model="data"
                :args="args"
                :db="db"
                :errors-post="errorsPost"
                :js-errors="jsErrors"
                :no-save="noSave"
                :options="policyCoverTypeOptions"
                :skipped="skipped"
                class="radio-options-wide"
                @jsErrors="jsErrors=$event"
                @serverErrors="serverErrors=$event"
                @skipped="skipped=$event" />
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../helpers/questionLoadHelpers";
import {policyOptions} from "../../options/policyOptions";

import QuestionBase from "../../QuestionBase";
import InputRadio from "@/components/common/questionnaires/question/inputs/InputRadio";

export default {
  name: 'CoverType',
  mixins: [
    questionLoadHelpers,
    policyOptions
  ],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    noSave: {
      type: Boolean,
      default: false
    },
    objectId: {
      type: Number,
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'Is the cover decreasing or level?',
        subTitle: 'Decreasing cover is usually for a mortgage or debt (the cover reduces as the debt reduces). Level cover pays out the same amount throughout the term of the policy.',
        tip: null
      },
      db: {
        saveLocation: 'client_policy',
        saveField: 'policyCoverType',
        objectId: this.objectId
      },
      args: {
        taggable: true,
        label: null,
        placeholder: 'Please select..',
        skippable: false,
        required: true,
        inputClass: 'field-75'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>